export const envOverride = {
  APP_NAME: 'fw-webadmin',
  VUE_APP_API_HOST: process.env.API_URL
}



// WEBPACK FOOTER //
// ./src/utils/envOverride.js